import React, { useEffect } from 'react';
import { Box } from '@material-ui/core';

import { Button, LinkButton, Select } from '@ds';
import CustomSwitch from '@DesignSystem/controllers/Switch/Switch';
import EmailIcon from '@Icons-outdated/EmailIcon.svg';
import { SlackLogoIcon } from '@Icons-outdated';
import { useOrganizations, useCurrentOrganization } from '@shared/hooks';
import { useSlackNotificationChannels } from '@mpm-druid/api';
import { useSlackConnectionStatus } from '@shared/api/useSlackConnectionStatus';
import { SLACK_STATUS } from '@shared/constants';

export default function StepTwo({
  fieldsState,
  setFieldsState,
  setActiveStep
}) {
  const { emailAlertOn, slackAlertOn, slackChannel } = fieldsState;
  const currentOrganization = useCurrentOrganization();

  const { data: userOrganizations } = useOrganizations();

  const userAdminOrganizationId =
    userOrganizations?.length > 0
      ? userOrganizations?.find(org => org.isAdmin === true)?.id
      : '';

  const { data: connectedSlackStatus } = useSlackConnectionStatus(
    {
      organizationId: currentOrganization?.id
    },
    { refetchOnWindowFocus: true, enabled: !!userAdminOrganizationId }
  );

  const { data: slackChannels } = useSlackNotificationChannels(
    currentOrganization?.id,
    {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      enabled: connectedSlackStatus === SLACK_STATUS.CONNECTED
    }
  );

  const isUserAdmin =
    !!userAdminOrganizationId &&
    currentOrganization?.id === userAdminOrganizationId;

  useEffect(() => {
    if (!slackAlertOn) {
      setFieldsState(prev => ({
        ...prev,
        slackChannel: undefined
      }));
    }
  }, [slackAlertOn, setFieldsState]);

  const slackChannelOptions =
    slackChannels?.data.map(({ channelId, channelName }) => {
      return {
        label: channelName,
        value: channelId
      };
    }) || [];

  return (
    <Box>
      <h6> Choose the notification channels you want to get notified with:</h6>
      <Box marginY={2.25} display="flex" alignItems="center">
        <CustomSwitch
          onChange={() =>
            setFieldsState(prev => ({
              ...prev,
              emailAlertOn: !prev.emailAlertOn
            }))
          }
          checked={emailAlertOn}
        />
        <div className="emailIcon">
          <EmailIcon />
        </div>
        <span>Email alert notification </span>
      </Box>
      <Box marginY={2.25} display="flex" alignItems="center">
        <CustomSwitch
          onChange={() =>
            setFieldsState(prev => ({
              ...prev,
              slackAlertOn: !prev.slackAlertOn
            }))
          }
          checked={slackAlertOn}
        />
        <div className="emailIcon">
          <SlackLogoIcon />
        </div>
        <span>Slack alert notification </span>
      </Box>
      {slackAlertOn && (
        <div className="inputMessageContainer">
          {connectedSlackStatus === SLACK_STATUS.CONNECTED ? (
            <div>
              <span>Choose the slack channel to send the alerts to:</span>
              <Select
                value={slackChannel}
                width={'220px'}
                onValueChange={value => {
                  setFieldsState(prev => ({
                    ...prev,
                    slackChannel: value
                  }));
                }}
                options={slackChannelOptions}
                variant="outlined"
              />
            </div>
          ) : (
            <div className="inputMessageContainer">
              {!isUserAdmin && (
                <span>
                  Contact Organization Administrator to setup Slack
                  Notifications
                </span>
              )}
              {isUserAdmin && (
                <div>
                  <div>Configure the Slack integration to send alerts</div>
                  <LinkButton
                    text="Configure"
                    openInNewTab
                    to={`/api/slack/oauth/start?organizationId=${userAdminOrganizationId}`}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <div className="stepTwoButtonWrapper">
        <Button onClick={() => setActiveStep(prev => prev + 1)}>Next</Button>
      </div>
    </Box>
  );
}
